import CompanyName from '../common/CompanyName';

const Sidebar = ({ handleSidebarToggle }: any) => {
  return (
    <div className='header-sidebar'>
      <div className='siderbar-top'>
        <div className='sidebar-log'>
          <a href='/'>
            <img
              alt='image'
              className='img-fluid'
              width={50}
              height={50}
              src='https://appthing-website.s3.ap-south-1.amazonaws.com/Logo.png'
            />
          </a>
          <CompanyName />
        </div>
        <div
          className='close-btn'
          onClick={() => {
            handleSidebarToggle();
          }}
        >
          <i className='bi bi-x-lg'></i>
        </div>
      </div>
      <div className='sidebar-content'>
        <p>
          Strategic, Insight-Driven Solutions Designed Exclusively Around Your
          Business Goals, Growth Plans, and Operational Realities
        </p>
      </div>
      <div className='address-card'>
        <div className='content'>
          <div className='informations'>
            <div className='single-info'>
              <div className='icon'>
                <i className='fas fa-map-marker-alt'></i>
              </div>
              <div className='info'>
                <p>
                  Gopal Krishna Building, Sector 30/31, CBD Belapur, Navi
                  Mumbai, Maharashtra 400614
                </p>
              </div>
            </div>
            <div className='single-info'>
              <div className='icon'>
                <i className='fas fa-phone-alt'></i>
              </div>
              <div className='info'>
                <a href='tel:+918986790869'>+91 8986790869</a>
              </div>
            </div>
            <div className='single-info'>
              <div className='icon'>
                <i className='far fa-envelope'></i>
              </div>
              <div className='info'>
                <a href='mailto:info@appthing.in'>info@appthing.in</a>
                <a href='mailto:support@appthing.in'>support@appthing.in</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='follow-area'>
        <h5 className='blog-widget-title'>Follow Us</h5>
        <p className='para'>Follow us on Social Network</p>
        <div className='blog-widget-body'>
          <ul className='follow-list d-flex flex-row align-items-start gap-4'>
            <li>
              <a
                href='https://www.linkedin.com/company/appthing'
                target='_blank'
              >
                <i className='bx bxl-linkedin'></i>
              </a>
            </li>
            <li>
              <a href='https://x.com/AppThing_HQ' target='_blank'>
                <i className='bx bxl-twitter'></i>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
